import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

function checkParentForClass(element, classname) {
	const class_name =
		element?.className && typeof element.className == 'string'
			? element.className
			: '';

	if (class_name.indexOf(classname) >= 0) {
		return true;
	}
	return (
		element.parentNode && checkParentForClass(element.parentNode, classname)
	);
}

const Clickable = ({ is: Component = 'span', onClick, url, ...props }) => {
	let initialPosition = { mouseX: 0, mouseY: 0 };
	const ref = useRef();

	const handleClick = (event, ref) => {
		if (
			initialPosition.mouseX != event.clientX ||
			initialPosition.mouseY != event.clientY
		) {
			event.preventDefault();
			return;
		}

		const link = ref.querySelector('a.clickable');
		let redirect_url = url;
		const class_name =
			event?.target?.className && typeof event.target.className == 'string'
				? event.target.className
				: '';

		const class_check =
			class_name.indexOf('btn') === -1 &&
			class_name.indexOf('offcanvas-backdrop') === -1 &&
			class_name.indexOf('text-decoration-none') === -1;

		const check_clickable_ignore = checkParentForClass(
			event.target,
			'clickable-ignore',
		);

		if (
			class_check &&
			!check_clickable_ignore &&
			link &&
			link.href &&
			!redirect_url
		) {
			redirect_url = link.getAttribute('href');
		}

		if (redirect_url) {
			event.preventDefault();
			navigate(redirect_url);
		}
	};
	if (!onClick) onClick = handleClick;

	const onMouseDown = (event) => {
		if (ref.current) {
			initialPosition = {
				mouseX: event.clientX,
				mouseY: event.clientY,
			};
		}
	};

	return (
		<Component
			aria-disabled={!onClick ? 'true' : undefined}
			onClick={onClick ? (event) => onClick(event, ref.current) : undefined}
			onMouseDown={onMouseDown}
			ref={ref}
			role="button"
			{...props}
		/>
	);
};

Clickable.displayName = 'Clickable';

Clickable.propTypes = {
	is: PropTypes.string,
	onClick: PropTypes.func,
	url: PropTypes.string,
};

export default Clickable;
